import { initDrops } from "./modules/common/drop";
import { initGlide } from "./modules/common/glide";
import { initSwiper } from "./modules/common/init-swiper";
import MapWidget from "./modules/partner/MapWidget";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

tippy('[data-tippy-content]', {
  theme: 'light'
});

// For the experiences slider widget type
initGlide();

initSwiper();

//for the currency dropdown
initDrops();

window.dispatchEvent(new Event('resize')) //glide fix workaround

// For the map widget type
new MapWidget();
